<template>
    <v-row justify="center">
      <v-col cols="12" class="pt-16">
        <v-container>
          <back-button @click.native="$router.go(-1)"></back-button>
          <h3 class="mb-4 home-header-3">
            Have you received either a 2 dose course of Bexsero® <b>OR</b> 2-dose course of Trumenba® (provided those doses were given at least 6 months apart) <b>OR</b> a 3-dose course of Trumenba® in the last 5 years?
          </h3>
          <v-radio-group
            v-model="ifReceivedBexseroOrTrumenba"
            class="mb-4"
          >
            <v-radio
              v-on:keyup.enter="
                ifReceivedBexseroOrTrumenba = 'Yes';
              "
              label="Yes"
              value="Yes"
              color="#006078"
              class="ml-4 px-8 py-4 black--text"
              :ripple="false"
            ></v-radio>
            <v-radio
              v-on:keyup.enter="
                ifReceivedBexseroOrTrumenba = 'No';
              "
              label="No"
              value="No"
              color="#006078"
              class="ml-4 px-8 py-4 black--text"
              :ripple="false"
            ></v-radio>
          </v-radio-group>
          <v-btn
            @click="onAfterContinueClicked"
            class="v-btn--primary"
            :disabled="!ifReceivedBexseroOrTrumenba"
          >
            Continue
          </v-btn>
        </v-container>
      </v-col>
    </v-row>
  </template>
  
  <script>
  import Vue from 'vue';
  import BackButton from '@/components/BackButton';
  
  export default Vue.extend({
    components: { BackButton },
    name: 'StepMeningitisB1',
    data: () => ({
      ifReceivedBexseroOrTrumenba: null
    }),
    mounted: function() {
      this.$store.commit('setMeningitisBDose', null);
      this.$store.commit('setIsEligibleForMeningitisBVaccine', null);
    },
    methods: {
      onAfterContinueClicked() {
        this.$gtag.event('Received either a 2 dose course of Bexsero® or 2-dose course of Trumenba® answered', {})
        if (this.ifReceivedBexseroOrTrumenba === 'No') {
          this.$router.push('/booking/meningitis-b-2').catch(() => {});
        } else {
          this.$router.push('/booking/meningitis-b-not-eligible').catch(() => {});
        }
      }
    }
  });
  </script>
  